import React, { useState, useEffect } from "react";
import Select from "../../../components/select/selectField";
import MainButton from "../../../components/button/mainButton";
import TextBox from "../../../components/textfield/textbox";
import HeaderBar from "../../../components/header/headerBar";
import { useHistory } from "react-router-dom";
import { Input } from "../../../components/textfield";
import Icon from "@mdi/react";
import { mdiPrinter } from "@mdi/js";
import "../../../assets/styles/admin/usedcourse.scss";

const Creategift = () => {
  const history = useHistory();
  const givename = [{ value: "", name: "ทรงอัปสร เกตุนิมะ (หมิว)" }];
  const approve = [{ value: "", name: "จันทร์ มูลสาร (เพ็ญ)" }];

  return (
    <div>
      <HeaderBar title="GIFT VOUCHER / CREATE" btnBack />
      {/* <ConFirmModal type={1} show={showModal1} onClose={toggleModal1} /> */}
      <div style={{ padding: "20px 40px" }}>
        <div className="card-view" style={{ padding: "30px 10px" }}>
          <div style={{ padding: "0px 10px" }}>
            <h5>สร้าง GIFT VOUCHER</h5>
          </div>
          <div className="row" style={{ padding: "10px 40px" }}>
            <TextBox
              className="col-4 text-box-usedc"
              title="Customer"
              value="น.ส ธันยรัศมิ์ จิระรุ่งโรจน์"
            />
            <TextBox
              className="col-4 text-box-usedc"
              title="CN"
              value="R9-CNT61080007"
            />
            <TextBox
              className="col-4 text-box-usedc"
              title="Voucher No."
              value="GE.000005"
            />
          </div>
          <div className="row" style={{ padding: "10px 40px" }}>
            <Input
              type="date"
              className="col-4 input-usedc"
              title="วันที่ออก"
              value="2564-09-10"
            />
            <Input
              type="date"
              className="col-4 input-usedc"
              title="วันหมดอายุ"
              value="2564-12-10"
            />
            <TextBox
              className="col-4 text-box-usedc"
              title="ทรีเม้นต์"
              value="Super Blink"
            />
          </div>
          <div className="row" style={{ padding: "10px 40px" }}>
            <Input
              type="text"
              className="col-4 input-usedc"
              title="มูลค่า"
              value="6,500.00"
            />
            <Select
              className="col-4 select-field-usedc"
              title="มอบโดย"
              option={givename}
            />
            <Select
              className="col-4 select-field-usedc"
              title="ผู้อนุมัติ"
              option={approve}
            />
          </div>
          <div className="row" style={{ padding: "10px 40px" }}>
            <Input
              type="text"
              className="col-12 input-usedc"
              title="Detail"
              value="Super Blink"
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <MainButton
            className="mg-10"
            background="#E76464"
            title="ยกเลิก"
            to={`/setting/service/giftvoucher`}
          />
          <MainButton title="พิมพ์" background="#4285F4" className="mg-10">
            <Icon path={mdiPrinter} size="20" color="#fff" />
          </MainButton>
          <MainButton
            title="บันทึกข้อมูล"
            background="#4D7E7F"
            className="mg-10"
            onClick={() => history.push(`/usedcourse/1`)}
          />
        </div>
      </div>
    </div>
  );
};
export default Creategift;
